import HealthRecordListItem from './HealthRecordListItem';

export default HealthRecordListItem;



// WEBPACK FOOTER //
// ./src/components/Pages/Health/HealthRecordListItem/index.js